import { BlobProvider } from '@react-pdf/renderer';
import { useMemo } from 'react';
import { InvoicePDF } from '../InvoicePDF';
import InvoiceCanvasViewer from '../InvoiceCanvasViewer';
import { OrganizationWithPolicies } from '../../../commonTypes/organization.types';
import { InvoiceDto } from '../../../commonTypes/invoice.types';
import { InvoiceClientDto } from '../../../commonTypes/client.types';

type InvoiceItem = {
    title: string;
    subtitle: string;
    quantity: string;
    rate: string;
    tax: string;
    amount: string;
};

type InvoicePreviewProps = {
    items: InvoiceItem[];
    subtotal: string;
    tax: string;
    total: string;
    amountDue: string;
    invoice: Partial<InvoiceDto>;
    organization?: OrganizationWithPolicies;
    client: InvoiceClientDto;
};

export const InvoicePreview = ({ items, subtotal, tax, total, amountDue, invoice, organization, client }: InvoicePreviewProps) => {
    const pdfDocument = useMemo(
        () => (
            <InvoicePDF
                invoice={invoice}
                items={items}
                subtotal={subtotal}
                tax={tax}
                total={total}
                amountDue={amountDue}
                organization={organization}
                client={client}
            />
        ),
        [items, subtotal, tax, total, amountDue, invoice, organization, client]
    );

    return (
        <div
            style={{
                width: 800,
                height: 700,
                margin: '0 auto',
                borderRadius: 8,
                border: '1px solid #e2e8f0',
                overflow: 'hidden',
                background: '#f8fafc',
            }}
        >
            <BlobProvider document={pdfDocument}>
                {({ url, loading, error }) => {
                    if (loading) return <div style={{ padding: 16 }}>Loading…</div>;
                    if (error) return <div style={{ padding: 16, color: 'crimson' }}>{String(error)}</div>;
                    if (!url) return null;
                    return <InvoiceCanvasViewer url={url} />;
                }}
            </BlobProvider>
        </div>
    );
};
